'use client';

export interface FestaEntryInfoProps {
    festaEntryName?: string | null;
    scheduleLabels?: string[] | [];
    locationName?: string | null;
    entryTypeLabel?: string;
    entryTypeValue?: string | null;
}

export default function FestaEntryInfo({
    festaEntryName,
    scheduleLabels,
    locationName,
    entryTypeLabel = '',
    entryTypeValue,
}: FestaEntryInfoProps) {
    return (
        <div className="flex flex-col justify-start items-center w-full xl:w-[60%] py-2 md:py-6">
            <div className="text-center font-bold text-xl md:text-3xl text-color-base-2 pb-4">{festaEntryName}</div>
            <div className="flex flex-col">
                {scheduleLabels?.map((s) => (
                    <div key={s} className="text-center font-bold text-base md:text-base text-gray-500 pb-1">
                        {s}
                    </div>
                ))}
            </div>
            <div className="text-center font-bold text-base md:text-base text-gray-500 pb-1">{locationName}</div>
            <div className="text-center font-bold text-base md:text-base text-gray-500 py-4">
                {entryTypeLabel}：{entryTypeValue}
            </div>
        </div>
    );
}
